const Abbreviation = ["hct", "hgb", "rbc", "wbc"];

export default Abbreviation;
